import { ReducersTypes } from "constants/ReducersTypes";
import { getUXSettingsFromStorage } from "utils";

const savedDisputeFilters = getUXSettingsFromStorage("DISPUTE_LIST_FILTERS");

const initialState = {
  disputeList: [],
  dispute_status_count: {},
  dispute_type_count: {},
  filters: { ...savedDisputeFilters },
  isFetching: false,
  approvalDisputeList: [],
  approvalFilters: {},
  isApprovalFetching: false,
  exportedData: [],
  exporting: false,
  arUserList: [],
  assignedUser: {},
  selectedRows: [],
  isheaderchecked: false,
  isrowselected: false,
  reasonCodes: [], // Store dispute reason codes from API
};

export default function disputeReducer(state = initialState, action) {
  switch (action.type) {
    case ReducersTypes.SET_DISPUTE_LIST:
      return {
        ...state,
        disputeList: action.payload.disputeList || [],
        dispute_status_count: action.payload.dispute_status_count || {},
        dispute_type_count: action.payload.dispute_type_count || {},
        filters: action.payload.filters || {},
        isFetching: false,
      };
    case ReducersTypes.SET_DISPUTE_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case ReducersTypes.SET_APPROVAL_DISPUTE_LIST:
      return {
        ...state,
        approvalDisputeList: action.payload.disputeList || [],
        approvalFilters: action.payload.filters || {},
        isApprovalFetching: false,
      };
    case ReducersTypes.SET_APPROVAL_DISPUTE_FETCHING:
      return {
        ...state,
        isApprovalFetching: action.payload,
      };
    case ReducersTypes.UPDATE_DISPUTE:
      // Update or add dispute in list
      // eslint-disable-next-line no-case-declarations
      const existingIndex = state.disputeList.findIndex(
        (d) => d.id === action.payload.id
      );
      // eslint-disable-next-line no-case-declarations
      const updatedList = [...state.disputeList];
      if (existingIndex >= 0) {
        // Update existing dispute
        updatedList[existingIndex] = {
          ...updatedList[existingIndex],
          ...action.payload,
        };
      } else {
        // Add new dispute to the beginning of the list (for demo visibility)
        updatedList.unshift(action.payload);
      }
      return {
        ...state,
        disputeList: updatedList,
      };
    case ReducersTypes.DELETE_DISPUTE:
      return {
        ...state,
        disputeList: state.disputeList.filter((d) => d.id !== action.payload),
      };
    case ReducersTypes.BULK_UPDATE_DISPUTE_STATUS:
      return {
        ...state,
        disputeList: action.payload,
      };
    case ReducersTypes.SET_AR_DISPUTE_USER_LIST:
      return { ...state, arUserList: action.payload };
    case ReducersTypes.SET_DISPUTE_REASON_CODES:
      return { ...state, reasonCodes: action.payload };
    case ReducersTypes.SET_DISPUTE_EXPORTING:
      return {
        ...state,
        exporting: action.payload,
      };
    case ReducersTypes.SET_DISPUTE_EXPORT_DATA:
      return {
        ...state,
        exportedData: action.payload.exportedData || [],
        exporting: action.payload.exporting || false,
      };
    case ReducersTypes.EDIT_DISPUTES:
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
        isheaderchecked: action.payload.isheaderchecked,
        isrowselected:
          action.payload.selectedRows && !!action.payload.selectedRows.length,
        selectedDispute: action.payload.selectedDispute,
      };
    // Add more cases as needed
    default:
      return state;
  }
}
